import React from "react";
import './Footer.css';
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaTwitter } from 'react-icons/fa';


const Footer = () => {
    
    return (
        <div className='footer'>
            <div className="social-icons">
                <a href="https://www.instagram.com/"><FaInstagram /></a>
                <a href="https://www.facebook.com/"><FaFacebook /></a>
                <a href="https://twitter.com/"><FaTwitter /></a>
            </div>
            <div className="footer-headings"> 

            <div className="footer-links">
                <h3>Our Company</h3>
                <ul>
                    <li><Link to="/who-we-are">Who We Are</Link></li>              
                    <li><Link to="/about-snx">About SneakerXplore</Link></li>
                </ul>
            </div>
           
            <div className="footer-links">
                <h3>Customer Care</h3>
                <ul>
                    <li><Link to="/contact-us">Contact Us</Link></li>
                    <li><Link to="/faq">FAQ</Link></li>
                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                </ul>
            </div>


            </div>

            <p className="app-name">Copyright &copy; <Link to='/'>2024 SneakerXplore</Link> - All rights reserved</p>

        </div>
    );
}

export default Footer;
